module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "jarviswidget jarviswidget-color-blueLight m-t-10",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('index')) ? _c('button', {
    staticClass: "btn btn-sm m-r-10 btn-primary pull-right",
    staticStyle: {
      "border-radius": "0px !important",
      "height": "33px !important"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/vehicle-entry')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-check"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Ver todos")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-12 col-lg-12 text-right"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    class: 'fa ' + (_vm.searchTermIsDirty ? 'fa-spinner fa-pulse' : 'fa-search')
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive custom-scroll",
    staticStyle: {
      "max-height": "150px",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.entityEntries.length) ? _vm._l((_vm.entityEntries), function(entry) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(entry.full_name))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(entry.fabrication_year))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(entry.tenant.tenant_fancy_name))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(entry.renavam))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(entry.sale_price_formatted))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "1%"
      }
    }, [(_vm.profile.map['vehicle-entries'].includes('edit')) ? _c('button', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'VehicleEntryEdit',
            params: {
              id: entry.id
            }
          })
        }
      }
    }, [_vm._v("\n                          Detalhes\n                        ")]) : _vm._e()])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [(!_vm.searchTerm.length) ? [_c('i', {
    staticClass: "text-info fa fa-2x fa-inbox"
  }), _vm._v(" "), _c('h5', [_vm._v(" Não há veículos para esta unidade.\n                                "), (_vm.profile.map['vehicle-entries'].includes('create')) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.$router.push("/vehicle-entry/create")
      }
    }
  }, [_vm._v("\n                                   Clique aqui para criar nova entrada "), _c('i', {
    staticClass: "fa fa-fw fa-plus-circle"
  })]) : _vm._e()])] : [_c('i', {
    staticClass: "text-info fa fa-2x fa-inbox"
  }), _vm._v(" "), _c('h5', [_vm._v(" Não há veículos para esta busca.\n                                "), (_vm.profile.map['vehicle-entries'].includes('create')) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.searchTerm = ''
      }
    }
  }, [_vm._v("\n                                    Limpar filtro "), _c('i', {
    staticClass: "fa fa-fw fa-times-circle"
  })]) : _vm._e()])]], 2)])])]], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "jarviswidget jarviswidget-color-orange m-t-10",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    }
  }, [_vm._m(2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm m-r-10 bg-color-orange pull-right",
    staticStyle: {
      "border-radius": "0px !important",
      "height": "33px !important"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Reports',
          params: {
            aba: 'pendencies'
          }
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Ver todos")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-12 col-lg-12 text-right"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "",
      "type": "text"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive custom-scroll",
    staticStyle: {
      "height": "150px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.entityEntries), function(entry) {
    return (entry.pendencies.data.filter(function (e) { return !e.completed_at && Number(_vm.user.id) === Number(e.assigned_employee.id_key); }).length > 0) ? _c('tr', [_c('td', {
      attrs: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(entry.full_name))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20%"
      }
    }, [_c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("\n                        " + _vm._s(entry.pendencies.data.filter(function (e) { return !e.completed_at && Number(_vm.user.id) === Number(e.assigned_employee.id_key); }).length) + " Pendência(s) aguardando ação\n                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(entry.pendencies.data.filter(function (e) { return e.due && Number(_vm.user.id) === Number(e.assigned_employee.id_key); }).length) ? _c('i', {
      staticClass: "fa fa-warning fa-2x text-danger",
      attrs: {
        "title": "PENDÊNCIA ATRASADA"
      }
    }) : _c('i', {
      staticClass: "fa fa-clock-o text-success fa-2x",
      attrs: {
        "title": "PENDÊNCIA EM DIA"
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            path: '/vehicle-entry/' + entry.id + '/edit',
            query: {
              a: 'hr6'
            }
          })
        }
      }
    }, [_vm._v("\n                          Verificar pendências\n                        ")])])]) : _vm._e()
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "jarviswidget jarviswidget-color-red m-t-10",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    }
  }, [_vm._m(4), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm m-r-10 bg-color-red pull-right",
    staticStyle: {
      "border-radius": "0px !important",
      "height": "33px !important"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Reports',
          params: {
            aba: 'pendencies'
          }
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Ver todos")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-12 col-lg-12 text-right"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "",
      "type": "text"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive custom-scroll",
    staticStyle: {
      "height": "150px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.entityEntries), function(entry) {
    return (entry.pendencies.data.filter(function (e) { return !e.completed_at; }).length > 0) ? _c('tr', [_c('td', {
      attrs: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(entry.full_name))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20%"
      }
    }, [_c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("\n                        " + _vm._s(entry.pendencies.data.filter(function (e) { return !e.completed_at; }).length) + " Pendência(s) aguardando ação\n                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(entry.pendencies.data.filter(function (e) { return e.due; }).length) ? _c('i', {
      staticClass: "fa fa-warning fa-2x text-danger",
      attrs: {
        "title": "PENDÊNCIA ATRASADA"
      }
    }) : _c('i', {
      staticClass: "fa fa-clock-o text-success fa-2x",
      attrs: {
        "title": "PENDÊNCIA EM DIA"
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            path: '/vehicle-entry/' + entry.id + '/edit',
            query: {
              a: 'hr6'
            }
          })
        }
      }
    }, [_vm._v("\n                          Verificar pendências\n                        ")])])]) : _vm._e()
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "margin-bottom": "80px"
    }
  }, [_c('div', {
    staticClass: "jarviswidget jarviswidget-color-blue m-t-10",
    attrs: {
      "role": "widget"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-12 col-lg-12 text-right"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    class: 'fa ' + (_vm.searchTermIsDirtyOthersEntities ? 'fa-spinner fa-pulse' : 'fa-search')
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTermOthersEntities),
      expression: "searchTermOthersEntities"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTermOthersEntities)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTermOthersEntities = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive custom-scroll",
    staticStyle: {
      "max-height": "150px",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('show-details-entries-other-entities')) ? _c('th', [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.entriesOthersEntities.length) ? _vm._l((_vm.entriesOthersEntities), function(entry) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(entry.fipe_vehicle))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(entry.fabrication_year))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(entry.tenant.tenant_fancy_name))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(entry.renavam))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(entry.sale_price_formatted))]), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('show-details-entries-other-entities')) ? _c('td', {
      attrs: {
        "width": "1%"
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'VehicleEntryEdit',
            params: {
              id: entry.id
            }
          })
        }
      }
    }, [_vm._v("\n                          Detalhes\n                        ")])]) : _vm._e()])
  }) : [_vm._m(13)]], 2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-lg fa-car"
  }), _vm._v("\n            Últimos 5 carros adicionados no estoque \n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" Veículo")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" Ano Fab/Ano Modelo")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" Loja")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-ticket"
  }), _vm._v(" Placa")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-id-card"
  }), _vm._v(" Renavam")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" Preço")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-bell fa-lg"
  }), _vm._v("\n              Minhas Pendências\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" Veículo")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-ticket"
  }), _vm._v(" Placa")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Pendências")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Situação")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-warning fa-lg"
  }), _vm._v("\n              Veículos com Pendência\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" Veículo")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-ticket"
  }), _vm._v(" Placa")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Pendências")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Situação")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-archive fa-lg"
  }), _vm._v("\n              Estoque em outras lojas\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" Veículo")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" Ano Fab/Ano Modelo")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" Unidade")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-ticket"
  }), _vm._v(" Placa")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-id-card"
  }), _vm._v(" Renavam")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" Preço")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "text-info fa fa-2x fa-inbox"
  }), _vm._v(" "), _c('h5', [_vm._v("Não há veículos cadastrados nas demais unidades.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58313a3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 1018
// module chunks = 1